<template>
  <div
    class="box-border w-full bg-[#F5F6F7]"
    :class="isPC ? 'py-[40px] px-[40px]' : 'rounded-[20px] px-[24px] py-[48px]'"
  >
    <!-- 顶部：状态标签 + 参与人数 -->
    <PredictEventHeader
      :status="session.status"
      :participant-count="session.participantCount"
    />

    <!-- 股票信息插槽 -->
    <slot name="stock-info" />

    <!-- PC：白色内卡片 -->
    <div
      v-if="isPC"
      class="mt-[20px] rounded-[16px] bg-white px-[60px] py-[60px]"
    >
      <p class="text-center text-[32px] leading-[36px] text-[#121212]">
        {{ $label(session.question && session.question.title) }}
      </p>
      <ClosePriceAction
        class="mt-[40px]"
        :yesterday-price="yesterdayPrice"
        :my-answer="myVoteCode"
        :settled="settled"
        :correct-value="winnerCode"
        :settle-status="session.settleStatus"
        :editable="editable"
        @click-cta="handleClickCta"
      />
    </div>

    <!-- H5 -->
    <template v-else>
      <p class="mt-[40px] text-[32px] leading-[36px] text-[#121212]">
        {{ $label(session.question && session.question.title) }}
      </p>
      <ClosePriceAction
        class="mt-[28px]"
        :yesterday-price="yesterdayPrice"
        :my-answer="myVoteCode"
        :settled="settled"
        :correct-value="winnerCode"
        :settle-status="session.settleStatus"
        :editable="editable"
        @click-cta="handleClickCta"
      />
    </template>

    <!-- 页脚：倒计时 / 公布 / 结果 -->
    <PredictFooter
      :class="isPC ? 'mt-[32px]' : 'mt-[50px]'"
      :status="session.status"
      :deadline="session.deadline"
      :resolve-at="session.resolveAt"
      :result="result"
      :win-text="pick($t, 'resultWinClosest', 'resultWinClosestPredict')"
      @countdown-finish="emit('countdown-finish')"
    />
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { use as fegoUse } from '@fegobull/webapi';
import { useLocaleString, useFegoPageInfo } from '@ark/web-shared/use';
import { PREDICT_STATUS } from '../../shared/types';
import type { PredictResult, PredictSession } from '../../shared/types';
import type { MarketStatsResponse } from '@ark/predict-shared';
import PredictEventHeader from './header.vue';
import ClosePriceAction from './close-price-action.vue';
import PredictFooter from './footer.vue';
import { getPredictResult } from '../utils/predict-result';
import { useWording } from '../hooks/useWording';
import locales from '../locales';
const __sfc_main = {};
__sfc_main.props = {
  session: {
    key: "session",
    required: true,
    type: null
  },
  marketStats: {
    key: "marketStats",
    required: false,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    useI18n
  } = fegoUse;
  const $t = useI18n(locales);
  const $label = useLocaleString();
  const {
    isPC
  } = useFegoPageInfo();
  const {
    pick
  } = useWording();
  const yesterdayPrice = computed(() => {
    const scalar = props.session.answerSpec && props.session.answerSpec.scalar;
    return scalar && scalar.referencePrice != null ? scalar.referencePrice : '';
  });
  const myVoteCode = computed(() => props.session.myVoteCode);
  const winnerCode = computed(() => props.session.correctValue);
  const settled = computed(() => props.session.status === PREDICT_STATUS.SETTLED);
  const result = computed<PredictResult | null>(() => getPredictResult(settled.value, props.session.settleStatus));
  const editable = computed(() => {
    const {
      maxModifyCount,
      modifyCount,
      myVoteCode
    } = props.session;
    if (myVoteCode == null) return true;
    if (maxModifyCount < 0) return true;
    return modifyCount < maxModifyCount;
  });
  function handleClickCta() {
    emit('click-cta');
  }
  return {
    emit,
    $t,
    $label,
    isPC,
    pick,
    yesterdayPrice,
    myVoteCode,
    winnerCode,
    settled,
    result,
    editable,
    handleClickCta
  };
};
__sfc_main.components = Object.assign({
  PredictEventHeader,
  ClosePriceAction,
  PredictFooter
}, __sfc_main.components);
export default __sfc_main;
</script>
